import PropTypes from 'prop-types';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import * as rmd from 'material-ui';
import _ from 'lodash';
import auth from '../auth';
import config from 'cfg';
import Promise from 'bluebird';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FontIcon from 'material-ui/FontIcon';
import { browserHistory } from 'react-router';

class WidgetDemo extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            widget: {},
        };
        this.loadData();
    }

    loadData() {
        var { widgetId } = this.props.params;
        return Promise.props({
            widget: fetch(`${config.widgets.url}/widgets/standalone/${widgetId}/spec`).then(res => res.json()),
        })
            .then(result => {
                this.setState(result);
            })
            .catch(err => {
                console.error(err);
            });
    }

    static contextTypes = {
        user: PropTypes.object.isRequired,
    };

    renderDemo = demo => {
        var { user } = this.context;
        var { widget } = this.state;
        var previewProps = {};
        Object.keys(demo.props).forEach(key => {
            var wkey = 'data-' + _.kebabCase(key);
            previewProps[wkey] = demo.props[key];
        });

        return (
            <div className="col-md-6" key={demo.title}>
                <rmd.Card className="card widget-params">
                    <rmd.CardHeader title={demo.title} />
                    <rmd.CardText>
                        <rlz-widget
                            data-name={widget.id}
                            data-load="js"
                            data-client={user.client}
                            data-user={user.username}
                            data-theme="default"
                            data-token={user.accessToken}
                            data-ga="$GA_INIT_TOKEN"
                            data-lang="da"
                            {...previewProps}
                        />
                    </rmd.CardText>
                    <rmd.CardText>
                        <textarea
                            readOnly
                            style={{ width: '100%' }}
                            rows={5}
                            value={ReactDOMServer.renderToStaticMarkup(
                                <rlz-widget
                                    data-name={widget.id}
                                    data-load="js"
                                    data-client={user.client}
                                    data-user={user.username}
                                    data-theme="default"
                                    data-token={user.accessToken}
                                    data-ga="$GA_INIT_TOKEN"
                                    data-lang="da"
                                    {...previewProps}
                                />,
                            )}
                        />
                    </rmd.CardText>
                </rmd.Card>
            </div>
        );
    };
    handleOpenCreate = () => {
        var { widget } = this.state;
        browserHistory.push(`/widgets/${widget.id}/customizer`);
    };
    render() {
        var { user } = this.context;
        var { widgetId, name } = this.props.params;
        var { widget } = this.state;

        return (
            <div className="widget-demo">
                <rmd.Subheader>{name}</rmd.Subheader>
                <rmd.RaisedButton
                    onClick={this.handleOpenCreate}
                    label="Create widget"
                    secondary
                    icon={<ContentAdd />}
                />
                <div className="row">{(widget.demo || []).map(this.renderDemo)}</div>
            </div>
        );
    }
}

export default WidgetDemo;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/WidgetDemo.js
 **/